<template>
  <div 
    class="review-sidebar-component" 
    :class="{ 'is-inline-mode': isInline, 'is-fullheight': !isInline }"
  >
    <div 
      class="box" 
      :class="{ 'is-full': !isInline, 'is-fixed-top': !isInline }"
    >
      <div class="is-relative">
        <div class="columns pt-6 pl-6 no-overflow">
          <div class="column is-4">
            <div class="columns no-overflow">
              <div class="column is-8">
                <h1 class="is-size-2 is-size-3-mobile has-text-weight-bold">
                  Seu plano
                </h1>
              </div>
              <div class="column is-4 is-flex is-align-items-center">
                <button
                    class="button is-primary tooltip-button is-right has-tooltip-multiline has-tooltip-left"
                    data-tooltip="O valor final cobrado para a contratação de seu plano, expresso no boleto ou na fatura de seu cartão, poderá ser menor, devido a política tributária da Pedbot, que trabalha com retenção de alguns impostos no tomador dos serviços. Caso tenha dúvidas, contacte nossa equipe ou fale com o vendedor"
                >
                  ?
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="pl-6 box-scroll-content no-overflow" :class="{ 'no-scroll': isInline }">
          <div class="columns mt-6 no-overflow">
            <div class="column is-12">
              <steps
                  ref="reviewSteps"
                  :formData="formData"
                  :fullWidth="isInline"
              ></steps>
            </div>
          </div>
          <hr class="is-box-width" :class="{ 'full-width-hr': isInline }">
          <div class="columns mt-2 is-box-width no-overflow" :class="{ 'full-width-content': isInline }">
            <div class="column is-12">
              <review-extra-services
                  :formData="formData"
                  :steps="steps"
              ></review-extra-services>
            </div>
          </div>
          <hr class="is-box-width" :class="{ 'full-width-hr': isInline }">
          <div class="columns mt-2 is-box-width no-overflow" :class="{ 'full-width-content': isInline }">
            <div class="column is-12">
              <sum-description
                  :formData="formData"
                  :steps="steps"
                  :onlyUnique="false"
              ></sum-description>
            </div>
          </div>
        </div>
        <div 
          class="columns pl-6 mt-2 is-box-width is-fixed-bottom no-overflow" 
          :class="{ 'full-width-content': isInline, 'relative-bottom': isInline }" 
          v-if="AppStoreStore.showReviewNextButton"
        >
          <div class="column">
            <next-button
              @nextTab="$emit('nextTab')"
              position="center"
              sizeClass="is-fullwidth"
            ></next-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Steps from "./Steps/Index";
import NextButton from "../Tabs/NextButton";
import SumDescription from "./SumDescription/Index";
import ReviewExtraServices from "./ReviewExtraServices/Index";
import {useAppStore} from "@/stores/AppStore";
import {mapStores} from 'pinia'

export default {

  name: 'review-sidebar',

  props: {
    formData: {
      required: true,
      type: Object
    },
    isInline: { // Nova prop adicionada
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      steps: [],
      totalExtraServicesPrice: 0
    }
  },

  components: {
    NextButton,
    Steps,
    SumDescription,
    ReviewExtraServices
  },

  computed: {
    ...mapStores(useAppStore)
  },

  mounted () {
    this.$watch(
      () => {
        return this.$refs.reviewSteps.steps
      },
      () => {
        this.populateSteps()
      }
    )
    this.populateSteps()
    this.calculateTotalExtraServicesPrice()
  },

  methods: {
    populateSteps() {
      this.steps = this.$refs.reviewSteps.steps
    },
    parseExtraServicePrice(extraService) {
      return parseFloat(extraService.price) * extraService.quantity
    },
    calculateTotalExtraServicesPrice() {
      let total = 0
      for (const extraService of this.formData.extraServices.data) {
        total += this.parseExtraServicePrice(extraService)
      }
      this.totalExtraServicesPrice = total
    }
  }

}

</script>

<style lang="scss" scoped>
.review-sidebar-component {
  /* Estilos padrão */
  overflow-x: hidden !important;
  max-width: 100% !important;

  /* Aplica altura total apenas se NÃO for inline */
  &.is-fullheight:not(.is-inline-mode) {
    height: 100%;
  }

  .box {
    border-radius: 0px;
    background-color: white;
    margin-top: 0 !important;
    padding-top: 0 !important;
    overflow-x: hidden !important;
    max-width: 100% !important;

    /* Estilos de sidebar aplicados apenas se NÃO for inline */
    &:not(.is-inline-mode) {
      box-shadow: -8px 0.4em 0.5em -0.3em rgb(10 10 10 / 30%), 0 0px 0 1px rgb(10 10 10 / 2%);
      z-index: 20; /* Reduzido ainda mais para ficar abaixo da navbar */
    }

    &.is-full:not(.is-inline-mode) {
      height: calc(100vh - 60px); /* Ajustado para considerar a altura da navbar */
      width: 100vw;
    }

    &.is-fixed-top:not(.is-inline-mode) {
      position: fixed;
      top: 60px; /* Espaço para a navbar fixa */
      bottom: 0;
      overflow-y: auto;
      overflow-x: hidden !important;
    }

    .is-box-width {
      /* Largura original para sidebar */
      overflow-x: hidden !important;
      &:not(.full-width-content) {
         width: 30%;
      }
      /* Largura total para conteúdo inline */
      &.full-width-content {
        width: 100%;
        padding-left: 0; /* Remover padding esquerdo herdado */
      }
    }

    .is-fixed-bottom {
       /* Posição original para sidebar */
      &:not(.relative-bottom) {
        position: relative; /* Alterado de absolute para relative */
        z-index: 19;
        margin-bottom: 10px; /* Alterado bottom para margin-bottom */
      }
      /* Posição relativa para botão inline */
      &.relative-bottom {
        position: relative;
        bottom: auto;
      }
    }

    .box-scroll-content {
      /* Scroll apenas se NÃO for inline */
      overflow-x: hidden !important;
      max-width: 100% !important;
      
      &:not(.no-scroll) {
        max-height: calc(70vh - 60px); /* Ajustado para considerar a altura da navbar */
        overflow-y: auto;
        overflow-x: hidden !important;
        /* Removido o padding-bottom que estava criando espaço extra */
      }
      /* Sem scroll e altura máxima no modo inline */
      &.no-scroll {
        max-height: none;
        overflow-y: visible;
        overflow-x: hidden !important;
        padding-left: 0; /* Remover padding esquerdo herdado */
      }
    }

    hr {
      border: none;
      height: 3px;
      color: #dae6ec;
      background-color: #dae6ec;
      max-width: 100% !important;
      /* Largura total para HR inline */
      &.full-width-hr {
        width: 100%;
      }
    }
  }
  
  /* Estilos específicos para o modo inline */
  &.is-inline-mode {
    .box {
      /* Resetar estilos de sidebar */
      position: relative; /* Ou static, dependendo do necessário */
      height: auto;
      width: auto;
      overflow: visible;
      overflow-x: hidden !important;
      box-shadow: none; /* Remover sombra */
      padding: 0; /* Remover padding do box, o container mobile já tem */
    }
    .is-relative {
      /* Ajustes se necessário para o container relativo interno */
      overflow-x: hidden !important;
      max-width: 100% !important;
    }
  }
}

.no-overflow {
  overflow-x: hidden !important;
  max-width: 100% !important;
  width: 100%;
}

@media screen and (max-width: 768px) {
  .review-sidebar-component {
    .box {
      &.is-fixed-top:not(.is-inline-mode) {
        top: 50px; /* Menor no mobile */
      }
      
      &.is-full:not(.is-inline-mode) {
        height: calc(100vh - 50px); /* Ajustado para considerar a altura da navbar mobile */
      }
    }
    
    .box-scroll-content {
      &:not(.no-scroll) {
        max-height: calc(70vh - 50px); /* Ajustado para considerar a altura da navbar mobile */
      }
    }
    
    .columns, .column {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 0.5rem !important;
      padding-right: 0.5rem !important;
    }
    
    .is-size-3-mobile {
      font-size: 1.75rem !important;
    }
    
    .pl-6 {
      padding-left: 0.75rem !important;
    }
    
    .is-box-width:not(.full-width-content) {
      width: 100% !important; /* Força largura total no mobile mesmo no modo sidebar */
    }
  }
}
</style>